import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
  makeStyles,
  Grid,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  IconButton,
  Divider,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { orange } from '@material-ui/core/colors'
import {
  withStyles,
} from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Page from 'src/components/Page'
import { useParams } from 'react-router-dom'
import styles from './Certificate.module.css'
import { CssTextField } from '../../utils/CustomInputs'
import { bankPortals } from '../../components/bankPortal/BankPortal'
import {
  payCourseCertificate,
  checkCertificateDiscount,
  selectorDiscountPrice,
} from '../../app/slices/courseSlice'
import CallIcon from '../../icons/CallIcon'
import {
  selectorUserAddress, getUserAddresses,
  addUserAddress,
} from '../../app/slices/userSlice'
import { thousandSeperator } from '../../utils/getInitials'

const OrangeCheckbox = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .length(11, 'حتما باید 11 رقمی باشد'),
  postalCode: Yup.string()
    .length(10, 'حتما باید 10 رقمی باشد'),
})

const useStyles = makeStyles((theme) => ({
  root: {},
  item: {
    padding: theme.spacing(1),
    height: theme.spacing(11),
  },
  certificateBtn: {
    backgroundColor: '#e6332a',
    width: '100px',
    height: '37px',
    borderRadius: '20px',
    color: '#ffffff',
    textAlign: 'center',
    fontWeight: '600',
    display: 'flex',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },

  certificateBtnWrapp: {
    display: 'flex',
    width: '100%',
    justifyContent: 'end',
    margin: '10px 0 20px',
    paddingRight: '15px',
  },

  bankGroup: {
    margin: '30px 11px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  portal: {
    marginBottom: theme.spacing(2),
    width: '35%',
    '@media (max-width: 960px)': {
      width: '70%',
    },
    '@media (max-width: 500px)': {
      width: '100%',
    },
  },
  portalLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.spacing(1.5),
    },
  },
  bankImage: {
    width: theme.spacing(9.1),
    height: theme.spacing(7.7),
    verticalAlign: 'middle',
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(6.1),
      height: theme.spacing(4.7),
    },
  },
  addressWrap: {
    margin: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  headingAddress: {
    color: '#000',
    fontSize: '16px',
    fontWeight: 600,
    marginLeft: '15px',
    marginTop: '20px',
  },
  addAddressIcon: {
    color: '#1b6edb',
    width: '60px',
    height: '60px',
  },
  addAddress: {
    marginBottom: '120px',
  },
  discountBtnWrap: {
    '@media (max-width: 1360px)': {
      marginLeft: '10px',
    },
  },
  discountBtn: {
    backgroundColor: '#e6332a',
    width: '120px',
    height: '40px',
    borderRadius: '20px',
    color: '#fff',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    display: 'flex',
    margin: '10px auto 0',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
    '@media (max-width: 960px)': {
      alignItems: 'end',
      margin: '10px',
      float: 'right',
      width: '100px',
      fontSize: '13px',
    },

  },
  discountWrap: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const Certificate = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const userAddresses = useSelector(selectorUserAddress)
  const discountPrice = useSelector(selectorDiscountPrice)
  const { courseGroupId } = useParams()

  const [errorMsg, setErrorMsg] = useState('')
  const [selectedAddress, setSelectedAddress] = useState(null)

  useEffect(() => {
    dispatch(getUserAddresses())
  }, [])

  const formik = useFormik({
    initialValues: {
      username: '',
      phoneNumber: '',
      address: '',
      postalCode: '',
      discount: '',
      selectedAddress: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (fields) => {
      const Meta = {
        CourseGroupId: courseGroupId,
        UserAddressId: selectedAddress,
      }

      const { portal, discount } = fields
      const ipg = bankPortals.findIndex((bank) => bank.name === portal) + 1
      const discountcode = discount || undefined
      const callBackUrl = `${window.location.origin}/BankResult`
      const PayRequest = {
        ipg,
        discountcode,
        callBackUrl,
      }

      if (selectedAddress && ipg) {
        dispatch(payCourseCertificate({ Meta, PayRequest }))
      }
    },

  })

  const addAddress = () => {
    console.log(formik?.value?.selectedAddress)
    const address = {
      title: formik.values.title,
      address: formik.values.address,
      postalCode: formik.values.postalCode,
      phoneNumber: formik.values.phoneNumber,
    }

    if (
      formik.values.titlerow
      && formik.values.address
      && formik.values.postalCode
      && !formik.errors.postalCode
      && formik.values.phoneNumber
      && !formik.errors.phoneNumber
    ) {
      dispatch(addUserAddress(address))
      formik.values.title = ''
      formik.values.address = ''
      formik.values.postalCode = ''
      formik.values.phoneNumber = ''
      setErrorMsg('')
    } else {
      setErrorMsg('لطفا تمام فیلد ها را تکمیل کنید')
    }
  }

  const addDiscount = () => {
    if (formik.values.discount) {
      dispatch(checkCertificateDiscount(formik.values.discount, 4))
    }
  }

  return (
    <Page
      title="درخواست گواهینامه"
    >
      <div
        className={styles.certificate_section1}
      >
        <p
          className={styles.certificate_Title}
        >
          گواهی‌نامه گارنت نماد متخصص بودن شماست، لطفاً آدرس موردنظر برای ارسال گواهی‌نامه
          را انتخاب کنید و سپس مبلغ 480 هزار تومان پرداخت کنید.
        </p>
        <form
          onSubmit={formik.handleSubmit}
        >

          {userAddresses?.data?.map((item) => (
            <>
              <div
                key={item?.id}
                className={classes.addressWrap}
              >
                <div
                  className={classes.addressIconsWrap}
                >

                  <FormControlLabel
                    classes={{ root: classes.portal, label: classes.portalLabel }}
                    control={(
                      <OrangeCheckbox
                        value={selectedAddress}
                        checked={formik.values.selectedAddress === item?.id}
                        name={item?.title}
                        onChange={() => {
                          console.log(item?.id)
                          setSelectedAddress(item?.id)
                          formik.setFieldValue('selectedAddress', item?.id)
                        }}
                      />
                    )}
                  />
                </div>
                <p style={{ marginBottom: '18px' }}>{item?.address}</p>

              </div>
              <Divider />
            </>
          ))}
          <Typography className={classes.headingAddress}>
            افزودن آدرس جدید
          </Typography>
          <Grid
            item
            xs={12}
            container
          >
            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.title && formik.errors.title)}
                fullWidth
                helperText={formik.touched.title && formik.errors.title}
                label="عنوان"
                margin="normal"
                name="title"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.title}
                variant="outlined"
              />
            </Grid>

            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.postalCode && formik.errors.postalCode)}
                fullWidth
                helperText={formik.touched.postalCode && formik.errors.postalCode}
                label="کد پستی"
                margin="normal"
                name="postalCode"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.postalCode}
                variant="outlined"
                inputProps={{
                  maxLength: 10,
                  pattern: '[0-9]*',
                }}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.phoneNumber && formik.errors.phoneNumber)}
                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                fullWidth
                label="شماره موبایل"
                margin="normal"
                name="phoneNumber"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.phoneNumber}
                variant="outlined"
                inputProps={{
                  maxLength: 11,
                  pattern: '[0-9]*',
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            classes={{ root: classes.item }}
            className={classes.addAddress}
          >
            <CssTextField
              error={Boolean(formik.touched.address && formik.errors.address)}
              fullWidth
              helperText={formik.touched.address && formik.errors.address}
              label="آدرس"
              margin="normal"
              name="address"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="text"
              value={formik.values.address}
              variant="outlined"
              multiline
              rows={2}
              maxRows={8}
            />

            <p style={{ color: '#ff3434' }}>{errorMsg}</p>
            <IconButton onClick={addAddress}>
              <AddCircleIcon
                classes={{ root: classes.addAddressIcon }}
              />
            </IconButton>
          </Grid>
          <Divider />

          <Grid
            container
            xs={12}
            className={classes.discountWrap}
          >
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
              CssTextField
            >
              <CssTextField
                error={Boolean(formik.touched.discount && formik.errors.discount)}
                fullWidth
                helperText={formik.touched.discount && formik.errors.discount}
                label="کد تخفیف"
                margin="normal"
                name="discount"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.discount}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
              className={classes.discountBtnWrap}
            >
              <Button
                onClick={addDiscount}
                className={classes.discountBtn}
              >
                اعمال تخفیف
              </Button>
            </Grid>
          </Grid>

          {discountPrice || discountPrice === 0 ? (
            <>

              <p style={{ margin: '7px auto' }}>
                کد تخفیف شما:
                {' '}
                {formik.values.discount}
              </p>

            </>
          ) : null}
          {discountPrice || discountPrice === 0 ? (
            <h4
              style={{ margin: '5px auto 0 auto', color: 'green' }}
            >
              {discountPrice !== 0 ? `${t('fee_payable')}: ${discountPrice
                ? thousandSeperator(discountPrice ?? 0) : thousandSeperator(450)} ${t('rials')}` : 'رایگان'}
            </h4>
          ) : null}

          <Grid
            xs={12}
          >

            <FormGroup classes={{ root: classes.bankGroup }}>
              {
bankPortals?.map((portal, i) => (
  <FormControlLabel
    classes={{ root: classes.portal, label: classes.portalLabel }}
    key={i}
    control={(
      <OrangeCheckbox
        checked={formik.values.portal === portal.name}
        onChange={() => formik.setFieldValue('portal', portal.name)}
        name={portal.name}
      />
)}
    label={(
      <>
        {t(portal.desc)}
        <img src={portal.url} alt={portal.name} className={classes.bankImage} />
      </>
)}
  />
))
}
            </FormGroup>
          </Grid>

          <div className={classes.certificateBtnWrapp}>
            <Button
              type="Submit"
              className={classes.certificateBtn}
            >
              پرداخت
            </Button>
          </div>
        </form>
      </div>

      <div
        className={styles.certificate_section2}
      >
        <p
          className={styles.certificate_section2_title}
        >
          در صورت بروز هر گونه مشکل با پشتیبانی تماس بگیرید.
        </p>
        <div
          className={styles.certificate_section2_contact_wrapp}
        >
          <soan
            className={styles.certificate_section2_contact_numbers}
          >
            02126159064
          </soan>
          <soan
            className={styles.certificate_section2_contact_icon}
          >
            <CallIcon />
          </soan>
        </div>
        <div />
      </div>
    </Page>
  )
}

export default Certificate
